<mat-dialog-title>
    <h2 style="font-weight: bold;">{{ 'REQUEST_SUMMARY_HEADING' | translate }} 
        <span style="float:right; cursor:pointer;" class="fa-solid fa-print" (click)="print()"></span>
    </h2>
</mat-dialog-title>

<mat-dialog-actions style="margin: 0px 25px 0px 25px;" class="responsive-actions">
    <div style="font-weight: bold; margin-right: 5px;">{{ 'REQUEST_SUMMARY_ANOTHER_REQUEST' | translate }}</div>
    <button mat-button class="btn-yes" (click)="extendSession()">{{ 'REQUEST_SUMMARY_BTN_YES' | translate }}</button>
    <button mat-button class="btn-no" (click)="logout()">{{ 'REQUEST_SUMMARY_BTN_NO' | translate }}</button>
</mat-dialog-actions>

<mat-dialog-content>
    <div style="margin: 10px;" id="printSummarySectionId">
        <h3>{{ 'REQUEST_SUMMARY_REFERENCE_NUM' | translate }} {{ referenceNumber }}</h3>
        <p class="subtitle">{{ 'REQUEST_SUMMARY_NOTE' | translate }}</p>
        <h3>{{ heading }}</h3>
        <table id="dataTable">
            <tbody></tbody>
        </table>
    </div>
</mat-dialog-content>